<mat-button-toggle-group
    [(ngModel)]='selection'
    (ngModelChange)='selectionChange($event)'
    name='selection'
    aria-label='View selection'
>
    <mat-button-toggle [disabled]='gallery !== ListingDisplayMode.Table' [value]='true'>Metrics</mat-button-toggle>
    <mat-button-toggle [disabled]="gallery !== ListingDisplayMode.Attributes" [value]="false">Attributes</mat-button-toggle>
</mat-button-toggle-group>
